import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getEventBySlug } from '../../../../../../app/store/slices/event/event';
import { deleteAllTicketById } from '../../../../../../app/store/slices/ticket/ticket';
import useEvent from '../../../../../../hooks/event-hooks/useEvent';
import { errorToast } from '../../../../../../utils/toasts/toasts';

export default function useEventSchedule() {
    const eventTypes = {
        single: 'single_day',
        multi: 'multi_day',
        continuous: 'continuous'
    };
    const dispatch = useDispatch();
    const { eventData } = useSelector((state) => state.event);
    const { allTicketsIds } = useSelector((state) => state.ticket);
    const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);
    const [shouldShowEditButton, setShouldShowEditButton] = useState(false);
    const [selectedEventType, setSelectedEventType] = useState(
        eventData?.event_type || eventTypes.single
    );
    const [hoveredEventType, setHoveredEventType] = useState(null);
    const [isEditModeOn, setIsEditModeOn] = useState(true);
    const [ticketLoading, setTicketLoading] = useState(false);

    const {
        isTicketCreated,
        isScheduleCompleted,
        isEventDrafted,
        isEventLive,
        // isAnyTicketSold
    } = useEvent()

    const eventTypeTooltips = {
        [eventTypes.single]: 'Your event starts and ends on the same date.',
        [eventTypes.multi]: 'Your event occurs on multiple dates.',
        [eventTypes.continuous]: 'Your event starts and ends on different dates.'
    };

    // // manage the visibility of edit button based on event status and schedule details
    // useEffect(() => {
    //     // Show edit button only when all conditions are met
    //     const shouldShow = isEventDrafted && isScheduleCompleted;

    //     setShouldShowEditButton(shouldShow);

    //     // Set edit mode to false if event is published or conditions for edit button are met
    //     setIsEditModeOn(!shouldShow || eventData?.publish === true ? false : true);
    // }, [eventData?.status, eventData?.is_publishable, eventData?.publish]);

    useEffect(() => {
        const shouldShow = isEventDrafted && isScheduleCompleted;
        setShouldShowEditButton(shouldShow);

        if (eventData?.publish || isEventLive) {
            // If published → always false
            setIsEditModeOn(false);
        } else if (!isScheduleCompleted || !isEventDrafted) {
            // If not completed OR not drafted → allow editing
            setIsEditModeOn(true);
        } else {
            // Both drafted & completed → disable edit mode
            setIsEditModeOn(false);
        }
    }, [isEventDrafted, isEventLive, isScheduleCompleted, eventData?.publish]);

    function handleEventReschedule() {
        if (isTicketCreated) {
            setOpenRescheduleDialog(true);
        } else {
            setOpenRescheduleDialog(false);
            setIsEditModeOn(true);
        }
    }

    async function handleOnConfirm() {
        try {
            setTicketLoading(true);
            await dispatch(deleteAllTicketById(allTicketsIds)).unwrap();
            await dispatch(getEventBySlug(eventData?.slug)).unwrap();
            setOpenRescheduleDialog(false);
            setIsEditModeOn(true);

        } catch (error) {
            errorToast(error?.data?.message || 'Failed to delete tickets');
        } finally {
            setTicketLoading(false);
        }
    }

    function handleOnCancel() {
        setOpenRescheduleDialog(false);
        setIsEditModeOn(false);
    }

    return {
        shouldShowEditButton,
        isEditModeOn,
        openRescheduleDialog,
        setOpenRescheduleDialog,
        handleEventReschedule,
        handleOnConfirm,
        handleOnCancel,
        ticketLoading,
        eventTypeTooltips,
        selectedEventType,
        setSelectedEventType,
        hoveredEventType,
        setHoveredEventType
    };
}

/**
 * what is happening wrong in this code i want to show edit button if event is in drafted and event schedule tab completed
 * and want to set edit mode true if isevent schedule tab is not completed or event is not in drafted and if thiese two conditions are true then want to set isEditmodeon false and also if event is publish then want to set edit mode false
 */